import { useEffect, useState } from "react";
import Fade from "../../components/Fade";
import LogoFooter from "../../components/LogoFooter";
import { useNavigate } from "react-router-dom";

export default function Etapa1() {
  const navigate = useNavigate();

  const [faixaetarias, setFaixas] = useState(null);
  const [generos, setGeneros] = useState(null);
  const [escolaridades, setEscolaridades] = useState(null);
  const [racasCor, setRacasCor] = useState(null);
  const [subprefeituras, setSubprefeituras] = useState(null);

  const [faixaSelecionada, setFaixaSelecionada] = useState("");
  const [generoSelecionado, setGeneroSelecionado] = useState("");
  const [escolaridadeSelecionada, setEscolaridadeSelecionada] = useState("");
  const [racaCorSelecionada, setRacaCorSelecionada] = useState("");
  const [subprefeituraSelecionada, setSubprefeituraSelecionada] = useState("");
  const [email, setEmail] = useState("");

  const [erros, setErros] = useState({});

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/faixaetarias`)
      .then((response) => response.json())
      .then((data) => setFaixas(data))
      .catch((error) => console.log(error));

    fetch(`${process.env.REACT_APP_API_URL}/api/generos`)
      .then((response) => response.json())
      .then((data) => setGeneros(data))
      .catch((error) => console.log(error));

    fetch(`${process.env.REACT_APP_API_URL}/api/escolaridades`)
      .then((response) => response.json())
      .then((data) => setEscolaridades(data))
      .catch((error) => console.log(error));

    fetch(`${process.env.REACT_APP_API_URL}/api/racacores`)
      .then((response) => response.json())
      .then((data) => setRacasCor(data))
      .catch((error) => console.log(error));

    fetch(`${process.env.REACT_APP_API_URL}/api/subprefeituras`)
      .then((response) => response.json())
      .then((data) => setSubprefeituras(data))
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    const dados = JSON.parse(localStorage.getItem("dadosPesquisa") || "{}");
    if (dados.faixaetaria) setFaixaSelecionada(dados.faixaetaria);
    if (dados.genero) setGeneroSelecionado(dados.genero);
    if (dados.escolaridade) setEscolaridadeSelecionada(dados.escolaridade);
    if (dados.racacor) setRacaCorSelecionada(dados.racacor);
    if (dados.subprefeitura) setSubprefeituraSelecionada(dados.subprefeitura);
    if (dados.email) setEmail(dados.email);
  }, []);

  const handleEnviar = () => {
    const novosErros = {};
    if (!faixaSelecionada) novosErros.faixa = "Campo obrigatório";
    if (!generoSelecionado) novosErros.genero = "Campo obrigatório";
    if (!escolaridadeSelecionada) novosErros.escolaridade = "Campo obrigatório";
    if (!racaCorSelecionada) novosErros.racacor = "Campo obrigatório";
    if (!subprefeituraSelecionada)
      novosErros.subprefeitura = "Campo obrigatório";

    setErros(novosErros);

    if (Object.keys(novosErros).length === 0) {
      const existentes = JSON.parse(
        localStorage.getItem("dadosPesquisa") || "{}",
      );

      const dadosFinais = {
        ...existentes,
        faixaetaria: faixaSelecionada,
        genero: generoSelecionado,
        escolaridade: escolaridadeSelecionada,
        racacor: racaCorSelecionada,
        subprefeitura: subprefeituraSelecionada,
        email: email || null,
      };

      fetch(`${process.env.REACT_APP_API_URL}/api/respostas/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dadosFinais),
      })
        .then((res) => {
          if (res.ok) {
            localStorage.removeItem("dadosPesquisa");
            navigate("/agradecimento");
          }
        })
        .catch(console.error);
    }
  };

  const enviarRespostas = () => {
    const dados = JSON.parse(localStorage.getItem("dadosPesquisa") || "null");

    if (!dados) {
      window.location.href = process.env.REACT_APP_ROOT_FOLDER || "/";
      return;
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/respostas/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dados),
    })
      .then(() => {
        localStorage.removeItem("dadosPesquisa");
        window.location.href = process.env.REACT_APP_ROOT_FOLDER || "/";
      })
      .catch(console.error);
  };

  return (
    <>
      <Fade>
        <div className="w-full min-h-screen flex flex-col justify-between px-12 pt-12 pb-4">
          <div className="flex flex-col flex-1">
            <div className="mb-12">
              <h1 className="text-6xl font-bold text-deepBlue">
                Formulário de dados socieconômicos
              </h1>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10">
              <div className="block w-full">
                <label className="text-start text-3xl font-semibold text-deepBlue">
                  1. Faixa Etária:
                </label>
                <div className="w-full flex flex-col items-start mt-2">
                  <div className="relative w-full">
                    <select
                      className={`w-full px-6 py-4 pr-16 text-2xl bg-white border-2 rounded-3xl text-left text-gray-700 appearance-none cursor-pointer focus:outline-none transition ${
                        erros.faixa ? "border-red-500" : "border-[#c6d3df]"
                      }`}
                      value={faixaSelecionada}
                      onChange={(e) => {
                        setFaixaSelecionada(e.target.value);
                        if (e.target.value)
                          setErros((prev) => ({ ...prev, faixa: null }));
                      }}
                    >
                      <option value="" disabled>
                        Clique aqui para selecionar a faixa etária
                      </option>
                      {faixaetarias?.map((faixa) => (
                        <option key={faixa.id} value={faixa.id}>
                          {faixa.nome}
                        </option>
                      ))}
                    </select>
                    <svg
                      className="w-7 h-7 text-black absolute right-6 top-1/2 -translate-y-1/2 pointer-events-none"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 9l6 6 6-6"
                      />
                    </svg>
                  </div>
                  {erros.faixa && (
                    <span className="text-red-500 text-xl mt-1 block text-left">
                      {erros.faixa}
                    </span>
                  )}
                </div>
              </div>

              <div className="block w-full">
                <label className="text-start text-3xl font-semibold text-deepBlue">
                  2. Gênero:
                </label>
                <div className="w-full flex flex-col items-start mt-2">
                  <div className="relative w-full">
                    <select
                      className={`w-full px-6 py-4 pr-16 text-2xl bg-white border-2 rounded-3xl text-left text-gray-700 appearance-none cursor-pointer focus:outline-none transition ${
                        erros.genero ? "border-red-500" : "border-[#c6d3df]"
                      }`}
                      value={generoSelecionado}
                      onChange={(e) => {
                        setGeneroSelecionado(e.target.value);
                        if (e.target.value)
                          setErros((prev) => ({ ...prev, genero: null }));
                      }}
                    >
                      <option value="" disabled>
                        Clique aqui para selecionar o gênero
                      </option>
                      {generos?.map((genero) => (
                        <option key={genero.id} value={genero.id}>
                          {genero.nome}
                        </option>
                      ))}
                    </select>
                    <svg
                      className="w-7 h-7 text-black absolute right-6 top-1/2 -translate-y-1/2 pointer-events-none"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 9l6 6 6-6"
                      />
                    </svg>
                  </div>
                  {erros.genero && (
                    <span className="text-red-500 text-xl mt-1 block text-left">
                      {erros.genero}
                    </span>
                  )}
                </div>
              </div>

              <div className="block w-full">
                <label className="text-start text-3xl font-semibold text-deepBlue">
                  3. Escolaridade:
                </label>
                <div className="w-full flex flex-col items-start mt-2">
                  <div className="relative w-full">
                    <select
                      className={`w-full px-6 py-4 pr-16 text-2xl bg-white border-2 rounded-3xl text-left text-gray-700 appearance-none cursor-pointer focus:outline-none transition ${
                        erros.escolaridade
                          ? "border-red-500"
                          : "border-[#c6d3df]"
                      }`}
                      value={escolaridadeSelecionada}
                      onChange={(e) => {
                        setEscolaridadeSelecionada(e.target.value);
                        if (e.target.value)
                          setErros((prev) => ({ ...prev, escolaridade: null }));
                      }}
                    >
                      <option value="" disabled>
                        Clique aqui para selecionar a escolaridade
                      </option>
                      {escolaridades?.map((esc) => (
                        <option key={esc.id} value={esc.id}>
                          {esc.nome}
                        </option>
                      ))}
                    </select>
                    <svg
                      className="w-7 h-7 text-black absolute right-6 top-1/2 -translate-y-1/2 pointer-events-none"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 9l6 6 6-6"
                      />
                    </svg>
                  </div>
                  {erros.escolaridade && (
                    <span className="text-red-500 text-xl mt-1 block text-left">
                      {erros.escolaridade}
                    </span>
                  )}
                </div>
              </div>

              <div className="block w-full">
                <label className="text-start text-3xl font-semibold text-deepBlue">
                  4. Raça/Cor:
                </label>
                <div className="w-full flex flex-col items-start mt-2">
                  <div className="relative w-full">
                    <select
                      className={`w-full px-6 py-4 pr-16 text-2xl bg-white border-2 rounded-3xl text-left text-gray-700 appearance-none cursor-pointer focus:outline-none transition ${
                        erros.racacor ? "border-red-500" : "border-[#c6d3df]"
                      }`}
                      value={racaCorSelecionada}
                      onChange={(e) => {
                        setRacaCorSelecionada(e.target.value);
                        if (e.target.value)
                          setErros((prev) => ({ ...prev, racacor: null }));
                      }}
                    >
                      <option value="" disabled>
                        Clique aqui para selecionar raça/cor
                      </option>
                      {racasCor?.map((racaCor) => (
                        <option key={racaCor.id} value={racaCor.id}>
                          {racaCor.nome}
                        </option>
                      ))}
                    </select>
                    <svg
                      className="w-7 h-7 text-black absolute right-6 top-1/2 -translate-y-1/2 pointer-events-none"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 9l6 6 6-6"
                      />
                    </svg>
                  </div>
                  {erros.racacor && (
                    <span className="text-red-500 text-xl mt-1 block text-left">
                      {erros.racacor}
                    </span>
                  )}
                </div>
              </div>

              <div className="block w-full">
                <label className="text-start text-3xl font-semibold text-deepBlue">
                  5. Subprefeitura:
                </label>
                <div className="w-full flex flex-col items-start mt-2">
                  <div className="relative w-full">
                    <select
                      className={`w-full px-6 py-4 pr-16 text-2xl bg-white border-2 rounded-3xl text-left text-gray-700 appearance-none cursor-pointer focus:outline-none transition ${
                        erros.subprefeitura
                          ? "border-red-500"
                          : "border-[#c6d3df]"
                      }`}
                      value={subprefeituraSelecionada}
                      onChange={(e) => {
                        setSubprefeituraSelecionada(e.target.value);
                        if (e.target.value)
                          setErros((prev) => ({
                            ...prev,
                            subprefeitura: null,
                          }));
                      }}
                    >
                      <option value="" disabled>
                        Clique aqui para selecionar a subprefeitura
                      </option>
                      {subprefeituras?.map((subprefeitura) => (
                        <option key={subprefeitura.id} value={subprefeitura.id}>
                          {subprefeitura.nome}
                        </option>
                      ))}
                    </select>
                    <svg
                      className="w-7 h-7 text-black absolute right-6 top-1/2 -translate-y-1/2 pointer-events-none"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 9l6 6 6-6"
                      />
                    </svg>
                  </div>
                  {erros.subprefeitura && (
                    <span className="text-red-500 text-xl mt-1 block text-left">
                      {erros.subprefeitura}
                    </span>
                  )}
                </div>
              </div>

              <div className="block w-full">
                <label className="text-start text-3xl font-semibold text-deepBlue">
                  6. E-mail de contato:
                </label>
                <div className="w-full flex flex-col items-start mt-2">
                  <input
                    type="text"
                    className="w-full px-6 py-4 text-2xl bg-white border-2 border-[#c6d3df] rounded-3xl text-gray-700 placeholder:text-black focus:outline-none"
                    placeholder="Toque para digitar"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="w-full flex items-center justify-between mt-auto">
              <div className="flex gap-6 items-center">
                <button
                  onClick={enviarRespostas}
                  className="min-w-[200px] py-4 bg-blue-100 text-deepBlue px-12 rounded-2xl text-3xl font-semibold"
                >
                  Encerrar
                </button>
                <button
                  onClick={handleEnviar}
                  className="min-w-[200px] py-4 bg-deepBlue text-white px-12 rounded-2xl text-3xl font-semibold hover:bg-opacity-90 transition"
                >
                  Enviar
                </button>
              </div>

              <div className="p-6">
                <LogoFooter />
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </>
  );
}
